import { render, staticRenderFns } from "./NewDoc.vue?vue&type=template&id=35494c84"
import script from "./NewDoc.vue?vue&type=script&lang=js"
export * from "./NewDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports